const DOCUMENT = 'ATTENTION_REQUIRED_';

const actions = {
  LOAD_RESOLVED: DOCUMENT + 'LOAD_RESOLVED',
  LOAD_OUTSTANDING: DOCUMENT + 'LOAD_OUTSTANDING',
  LOAD_RESOLVED_SUCCESS: DOCUMENT + 'LOAD_RESOLVED_SUCCESS',
  LOAD_OUTSTANDING_SUCCESS: DOCUMENT + 'LOAD_OUTSTANDING_SUCCESS',
  RESOLVE_ACTION: DOCUMENT + 'RESOLVE_ACTION',
  REOPEN_ACTION: DOCUMENT + 'REOPEN_ACTION',
  PROCESS_ACTION: DOCUMENT + 'PROCESS_ACTION',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadResolvedData: data => ({
    type: actions.LOAD_RESOLVED,
    payload: data,
  }),

  loadOutstandingData: data => ({
    type: actions.LOAD_OUTSTANDING,
    payload: data,
  }),

  loadResolvedDataSuccess: data => ({
    type: actions.LOAD_RESOLVED_SUCCESS,
    payload: data,
  }),

  loadOutstandingDataSuccess: data => ({
    type: actions.LOAD_OUTSTANDING_SUCCESS,
    payload: data,
  }),

  resolveAction: data => ({
    type: actions.RESOLVE_ACTION,
    payload: data,
  }),

  reopenAction: data => ({
    type: actions.REOPEN_ACTION,
    payload: data,
  }),

  processAction: data => ({
    type: actions.PROCESS_ACTION,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
